// extracted by mini-css-extract-plugin
export default {"image":"styles_image__Ha1Yy","content":"styles_content__FuOMK","content4":"styles_content4__xW5IO","more":"styles_more__h8CLD","moreLeft":"styles_moreLeft__FPPCS"};